import { createFileRoute } from '@tanstack/react-router'

import { PlatformRenewalPage } from '../../../components/pages/backoffice/platform/platform-renewal-page.tsx'
import { PermissionChecker } from '../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/renewal/')({
  component: () => (
    <PermissionChecker requiredPermissions={['renewal.read']}>
      <PlatformRenewalPage />
    </PermissionChecker>
  ),
})
